import { Form, DatePicker } from 'antd';
import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { DARK } from '../../utilities/constants';
import dayjs from 'dayjs';
import Icon, {
  LeftOutlined,
  RightOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
} from '@ant-design/icons';
import { ReactComponent as Calender } from '../../assets/icons/calendar.svg';
import { ReactComponent as CalenderBlack } from '../../assets/icons/calender-black.svg';
import PropTypes from 'prop-types';

const CustomFormDatePicker = ({
  label,
  name,
  rules,
  width = '100%',
  showTime = false,
  className = 'custom-form-date-picker',
  maxDate = dayjs(dayjs().format('DD-MM-YYYY'), 'DD-MM-YYYY'),
  minDate = null,
}) => {
  const { theme } = useTheme();
  return (
    <Form.Item
      className={className}
      style={{ width }}
      name={name}
      label={label}
      rules={rules}
    >
      <DatePicker
        variant="borderless"
        // minDate={dayjs(dayjs().format('DD-MM-YYYY'), 'DD-MM-YYYY')}
        maxDate={maxDate}
        minDate={minDate}
        format={showTime ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY'}
        showNow={false}
        className="full-width"
        showTime={showTime}
        suffixIcon={
          <Icon component={theme === DARK ? Calender : CalenderBlack} />
        }
        prevIcon={
          <LeftOutlined
            style={{ color: theme === DARK ? '#FFFFFF' : '#000000' }}
          />
        }
        nextIcon={
          <RightOutlined
            style={{ color: theme === DARK ? '#FFFFFF' : '#000000' }}
          />
        }
        superPrevIcon={
          <DoubleLeftOutlined
            style={{ color: theme === DARK ? '#FFFFFF' : '#000000' }}
          />
        }
        superNextIcon={
          <DoubleRightOutlined
            style={{ color: theme === DARK ? '#FFFFFF' : '#000000' }}
          />
        }
      />
    </Form.Item>
  );
};

CustomFormDatePicker.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  rules: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showTime: PropTypes.bool,
  className: PropTypes.string,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
};

export default React.memo(CustomFormDatePicker);
